<template>
  <b-row>
    <b-col>
<!--      <b-row>-->
<!--        <b-col cols="12" lg="5">-->
<!--        </b-col>-->
<!--        <b-col>-->
<!--          <b-row>-->
<!--            <b-col>-->
<!--              <div class="form-group">-->
<!--                <label class="form-control-label">{{ $t('views.technicians.index.filters.carRegistrationNumber') }}:</label>-->
<!--                <input v-model.lazy="filters.carRegistrationNumber" v-debounce="delay" class="form-control" type="text" placeholder="">-->
<!--              </div>-->
<!--            </b-col>-->
<!--          </b-row>-->
<!--        </b-col>-->
<!--      </b-row>-->
      <b-row>
<!--        <b-col cols="12" lg="6">-->
<!--          <div class="form-group">-->
<!--            <label class="form-control-label">{{ $t('views.technicians.index.filters.status') }}:</label>-->
<!--            <el-select-->
<!--              v-model="filters.status"-->
<!--              multiple-->
<!--              filterable-->
<!--              remote-->
<!--              reserve-keyword-->
<!--              :placeholder="$t('views.technicians.index.filters.status')"-->
<!--              :remote-method="remoteMethod"-->
<!--              :loading="loading">-->
<!--              <el-option-->
<!--                v-for="item in statuses"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--        </b-col>-->
<!--        <b-col cols="12" lg="2">-->
<!--          <div class="form-group">-->
<!--            <label class="form-control-label">{{ $t('views.technicians.index.filters.activeOnly') }}:</label>-->
<!--            <b-form-group>-->
<!--              <b-form-radio-group-->
<!--                v-model="filters.activeOnly"-->
<!--                :options="radioOptions"-->
<!--                buttons-->
<!--                button-variant="outline-primary"-->
<!--                name="radios-btn-default"-->
<!--              ></b-form-radio-group>-->
<!--            </b-form-group>-->
<!--            &lt;!&ndash;                <b-form-checkbox v-model="filters.activeOnly" name="check-button" switch size="lg"></b-form-checkbox>&ndash;&gt;-->
<!--          </div>-->
<!--        </b-col>-->
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.technicians.index.filters.businessNumber') }}:</label>
            <input v-model.lazy="filters.businessNumber" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.technicians.index.filters.name') }}:</label>
            <input v-model.lazy="filters.name" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.technicians.index.filters.surname') }}:</label>
            <input v-model.lazy="filters.surname" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.firm.list.filters.state') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="filters.state"
                :options="radioOptions2"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
export default {
  name: 'ServicemenFiltering',

  data () {
    return {
      radioOptions: [
        {
          value: false,
          text: this.$t('buttons.no')
        },
        {
          value: true,
          text: this.$t('buttons.yes')
        }
      ],
      radioOptions2: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      delay: 500,
      filters: {
        status: [],
        activeOnly: true,
        businessNumber: '',
        name: '',
        surname: '',
        todayPlan: true,
        carRegistrationNumber: '',
        state: 1
      },
      statuses: [],
      loading: false
    }
  },

  directives: {
    debounce
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.$emit('addToSearchParams', this.filters)
      }
    }
  },
  methods: {
    remoteMethod () {
      // console.log()
    }
  }
}
</script>
